var JunoRecentlyViewed = (function (module, $) {
  'use strict';

  // Public functions
  var init;

  // Private plugin variables
  var $el;

  // Private general variables
  var numberOfItemsToTrack, thisProductHandle, allRecentProducts = [], productsAdded;

  init = function () {
    $el = jQuery('.recently-viewed .product-grid');
    numberOfItemsToTrack = 10;
    thisProductHandle = $el.attr('data-handle');
    productsAdded = 0;
    for (var i = 0; i < numberOfItemsToTrack; i++) {
      if (localStorage.getItem('recentlyViewed-' + i)) {
        if (productsAdded < (numberOfItemsToTrack - 1)) {
          if (thisProductHandle != localStorage.getItem('recentlyViewed-' + i)) {
            var productHandle = localStorage.getItem('recentlyViewed-' + i),
              productUrl = '/products/' + productHandle + '?view=item-ajax',
              productHTML = '';

            jQuery.ajax({
              type: 'GET',
              url: productUrl,
              processData: false,
              contentType: false,
              success: function (data) {
                productHTML = data;

                if ($el.hasClass('owl-carousel')) {
                  $el.trigger('add.owl.carousel', productHTML).trigger('refresh.owl.carousel');
                } else {
                  $el.append(productHTML);
                }
              }
            });
            productsAdded++;
          }
        }
      }
    }
    if (productsAdded > 0) {
      $el.parents('.recently-viewed').eq(0).addClass('show');
    }
  }

  module = {
    init: init
  };

  return module;
}(JunoRecentlyViewed || {}, jQuery));

jQuery(document).ready(function () {
  JunoRecentlyViewed.init();
});
